import { generateStripeState } from '../helper'

const options = {
  api: {
    list: () => `/api/stripe/subscriptions`,
    delete: ({ id }) => `/api/stripe/subscription/${id}`,
    update: ({ id }) => `/api/stripe/subscription/${id}`,
    get: ({ id }) => `/api/stripe/subscription/${id}`,
    create: () => `/api/stripe/subscription`,
  },
  state: {
    collectionName: 'subscriptions'
  },
  getters: {
    getPagination: 'getSubscriptionPagination',
    getCollection: 'getSubscriptions'
  },
  actions: {
    list: 'listSubscriptions',
    delete: 'deleteSubscription',
    update: 'updateSubscription',
    create: 'createSubscription',
    get: 'getSubscription'
  },
  mutationKey: 'SUBSCRIPTIONS',
}

const {
  state: stripeState,
  getters: stripeGetters,
  actions: stripeActions,
  mutations: stripeMutations
} = generateStripeState(options)


export default {
  state: {
    ...stripeState
  },
  getters: {
    ...stripeGetters
  },
  actions:{
    ...stripeActions,
    async cancelSubscriptionImmediately({ dispatch }, data) {
      const { id, prorate = false } = data

      const payload = {
        id,
        prorate,
        invoice_now: true,
      }

      const res = await dispatch('deleteSubscription', payload)
    },
    async cancelSubscriptionAtPeriodEnd({ dispatch }, data) {
      const { id } = data

      const payload = {
        id,
        cancel_at_period_end: true,
      }

      const res = await dispatch('updateSubscription', payload)
    }
  },
  mutations:{
    ...stripeMutations
  }
}
